export const HOME_STATES = {
  CONNECTED: 'DEPLOYE',
  PENDING: 'EN_COURS_DE_DEPLOIEMENT',
  TARGETED: 'CIBLE',
  SIGNE: 'SIGNE'
};

export const ZOOM_LEVELS = {
  DEFAULT: 11,
  FOCUSED: 18
};
